export default __webpack_public_path__ + "static/media/silver_reflection.66a389f7.png";